/** Display name for a user row from the admin users API. */
export function getUserDisplayName(user) {
  if (!user) return "User";
  const profiles = user.profiles || [];
  const primary = profiles.find((p) => p.is_primary) || profiles[0];
  return (
    primary?.full_name?.trim() ||
    primary?.profile_name?.trim() ||
    user.email ||
    "User"
  );
}
